import { request } from '../axios/request';

import {
  FETCH_CANCELLATION_REASONS_PENDING,
  FETCH_CANCELLATION_REASONS_FULFILLED,
  FETCH_ORDER_REFUND_PENDING,
  FETCH_ORDER_REFUND_REJECTED,
  FETCH_ORDER_REFUND_FULFILLED,
  SET_REFUNDED_ORDER_ITEMS,
} from '../constants/orderRefund';

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

export const setRefunderOrderItems = (
  order,
  orderItems,
  refundInvoiceNumber
) => ({
  type: SET_REFUNDED_ORDER_ITEMS,
  response: {
    order,
    orderItems,
    refundInvoiceNumber,
  },
});

const pending = () => ({
  type: FETCH_ORDER_REFUND_PENDING,
});

const cancellationReasonsPending = () => ({
  type: FETCH_CANCELLATION_REASONS_PENDING,
});

const fulfilled = (response) => ({
  type: FETCH_ORDER_REFUND_FULFILLED,
  response: response,
});

const cancellationReasonsFulfilled = (response) => ({
  type: FETCH_CANCELLATION_REASONS_FULFILLED,
  response: response,
});

const rejected = (error) => ({
  type: FETCH_ORDER_REFUND_REJECTED,
  error: error,
});

export const fetchCancellationReasons = () => (dispatch) => {
  dispatch(cancellationReasonsPending());

  request({ method: 'get', url: `${$U.CANCELLATION_REASONS}` })
    .then((response) => {
      dispatch(cancellationReasonsFulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const refundOrder = (data) => (dispatch) => {
  dispatch(pending());

  request({
    method: 'post',
    url: `${$U.ORDER_CANCEL}${data.order}`,
    data: data,
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};



// WEBPACK FOOTER //
// ./src/actions/orderRefund.js